module.exports = __webpack_public_path__ + "static/better-version.b79b405e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/better-version.jpg
// module id = 599
// module chunks = 35783957827783